module.exports = __webpack_public_path__ + "images/dingtalk/ad20160530/5-8152b01f8b4b24c9ed48b562b0d69ee0.png";